export default __webpack_public_path__ + "static/media/binance-logo.4338f514.svg";